export const candidateEmail = 'hello@spottedzebra.co.uk';
